"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultRentalProgramConfig = exports.DEFAULT_RENTAL_PROGRAM_CONFIGS = void 0;
const rentals_1 = require("./rentals");
exports.DEFAULT_RENTAL_PROGRAM_CONFIGS = {
    [rentals_1.RENTAL_PROGRAM_TYPES.UPANDUP]: {
        minimum_credit_score: 620,
        minimum_credit_score_with_additional_deposit: 600,
        standard_deposit_rent_multiple: 2,
        additional_deposit_rent_multiple: 3
    },
    [rentals_1.RENTAL_PROGRAM_TYPES.VANILLA]: {
        minimum_credit_score: 620,
        minimum_credit_score_with_additional_deposit: 570,
        standard_deposit_rent_multiple: 1,
        additional_deposit_rent_multiple: 2
    }
};
const getDefaultRentalProgramConfig = (rentalProgramType) => exports.DEFAULT_RENTAL_PROGRAM_CONFIGS[rentalProgramType !== null && rentalProgramType !== void 0 ? rentalProgramType : rentals_1.RENTAL_PROGRAM_TYPES.UPANDUP];
exports.getDefaultRentalProgramConfig = getDefaultRentalProgramConfig;
